var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99992 7.33333V10H4.66659V7.33333H5.99992ZM3.33325 6H4.66659H5.99992H7.33325V7.33333V10V11.3333H5.99992H4.66659H3.33325V10V7.33333V6ZM11.3333 7.33333V10H9.99992V7.33333H11.3333ZM8.66659 6H9.99992H11.3333H12.6666V7.33333V10V11.3333H11.3333H9.99992H8.66659V10V7.33333V6Z",
    fill: "#031D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.3333H4C3.63181 11.3333 3.33333 11.6318 3.33333 12C3.33333 12.3682 3.63181 12.6667 4 12.6667H12C12.3682 12.6667 12.6667 12.3682 12.6667 12C12.6667 11.6318 12.3682 11.3333 12 11.3333ZM4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10H4Z",
    fill: "#031D42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95244 5.99993H12.0476C12.3895 5.99993 12.6667 5.72275 12.6667 5.38083C12.6667 5.11841 12.5012 4.88451 12.2538 4.79709L8.22209 3.37263C8.07838 3.32186 7.92162 3.32186 7.77791 3.37263L3.74619 4.79709C3.49877 4.88451 3.33333 5.11841 3.33333 5.38083C3.33333 5.72275 3.61052 5.99993 3.95244 5.99993ZM3.30202 3.53991C2.52173 3.8156 2 4.55326 2 5.38083C2 6.45913 2.87414 7.33327 3.95244 7.33327H12.0476C13.1259 7.33327 14 6.45913 14 5.38083C14 4.55326 13.4783 3.8156 12.698 3.53991L8.66626 2.11546C8.23515 1.96314 7.76486 1.96314 7.33374 2.11546L3.30202 3.53991Z",
    fill: "#031D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLine);
export default __webpack_public_path__ + "static/media/bank-line.3222c709.svg";
export { ForwardRef as ReactComponent };